import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// V53: ResizeObserver 경고 억제 (React Flow 등에서 발생하는 무해한 경고)
// https://github.com/WICG/resize-observer/issues/38
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true; // 에러 무시
  }
  if (resizeObserverErr) {
    return resizeObserverErr(message, ...args);
  }
  return false;
};

// V60: 날짜 입력 연도 4자리 제한
// Chrome <input type="date">는 max 속성 미설정 시 연도 6자리 이상 입력 가능
// 전역 MutationObserver로 max 미설정 date input에 max="9999-12-31" 자동 적용
new MutationObserver(() => {
  document.querySelectorAll('input[type="date"]:not([max])').forEach(el => {
    el.setAttribute('max', '9999-12-31');
  });
}).observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
